
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-alert */
import React from 'react';
// import { Link } from 'react-router';
import classNames from 'classnames';
import { Field, FieldArray, reduxForm, change } from 'redux-form';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import {
  // dynamicSort,
  friendlyURICharacters,
  getDefaultIcon,
  // getQuestDurationHours,
  preloadRequirement,
  replaceSpaces,
  isAutoStreamQuest,
  isSecondaryCreationQuest,
  isStreamingQuest,
  isQuestTimeSetValid,
} from '../../utils/functions';
import { simpleNotification } from '../../utils/notifications';

import {
  getLanguageOptions,
  getCountryOptions,
  getPlatformOptions,
} from './QuestForm/constants/options';

import CustomInput from '../../utils/redux-forms-custom-fields/CustomInput';
import CustomInputCheckbox from '../../utils/redux-forms-custom-fields/CustomInputCheckbox';
// import CustomTagField from '../../utils/redux-forms-custom-fields/CustomTagField';
// import TiersWhitelist from './QuestForm/TiersWhitelist';
import { arrayDropDownColors } from '../../utils/constants';
import ArrayDropDown from '../../utils/redux-forms-custom-fields/ArrayDropDown';
import './skin.min.css';
// import RequiredGames from './QuestForm/RequiredGames';
// import TiersTaskMode from './QuestForm/TiersTaskMode';
// import { validateQuestForm } from './QuestForm/validators/questFormValidator';
import FAQs from './QuestForm/components/FAQs';
// import QuestDescriptions from './QuestForm/components/FAQs';
import Rules from './QuestForm/components/Rules';
// import StepsGeneric from './QuestForm/components/UserInfo/StepsGeneric';
// import Landing from './QuestForm/components/UserInfo/Landing';
// import LogsDisplay from './QuestForm/components/Logs/index';
// import EmailSettings from './QuestForm/components/UserInfo/EmailSettings';
// import Followers from './QuestForm/components/Followers';
import Requirements from './QuestForm/components/UserInfo/Requirements';
// import FormFooter from './QuestForm/components/FormFooter';
import WhiteList from './QuestForm/components/Parameters/WhiteList';
import MemberTiers from './QuestForm/components/Parameters/MemberTiers';
import ViewerTiers from './QuestForm/components/Parameters/ViewerTiers';
import SplitMode from './QuestForm/components/SplitMode/index';
import RankMode from './QuestForm/components/RankMode/index';
// import Details from './QuestForm/components/Details/index';
// import UploadModal from './QuestForm/modals/UploadModal';
import RichText from "../../utils/RichText";
// import {DATE_DISPLAY_FORMAT, DATE_STORE_FORMAT} from "./QuestForm/constants/dateFormats";
// import CustomDateTimePicker from "../../utils/redux-forms-custom-fields/CustomDateTimePicker";
import Dropzone from "react-dropzone";
// import {Button, TextField} from "@material-ui/core";
import {isBoolean} from "lodash";
import PropTypes from 'prop-types';
import DropActivitys from "./QuestForm/components/DropActivitys";

class TwitchDropForm extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.faqs = [];
    this.activitys = [];
    this.questDescriptions = [];
    this.state = {
      activeModal: 0,
      dropzoneActive: false,
      file: '',
      image: '',
      indexIcon: false,
      parametersSubTab: 0,
      pointInQuest: false,
      pointInQuestIcon: false,
      prevGamesPlayed: [],
      subTab: 'landing',
      tab: 'details',
      parametersAwardMode: 0,
      // 成就选择窗口状态
      achievementModal: {
        isOpen: false,
        pointInQuest: null,
        index: null,
        isModifying: false,
        modifyingAchievementId: null
      },
      // Steam 成就相关状态
      steamAchievements: {
        data: [],
        game: {},
        pagination: {},
        stats: {},
        isLoading: false,
        error: null
      }
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {

    if (this.props.preSignedUrl.isLoading === true && nextProps.preSignedUrl.isLoading === false) {
      const { data: signedUrl } = nextProps.preSignedUrl;
      console.log(signedUrl);
      this.uploadToS3(this.state.file, signedUrl.preSignedUrl);
    }

    if (this.props.twitchDrop && this.props.twitchDrop.isCreating === true && nextProps.twitchDrop.isCreating === false) {
      if (nextProps.twitchDrop.errors.hasError) {
        if (nextProps.twitchDrop.errors.code === 'E_TWITCH_DROP_SLUG_DUPLICATED') {
          this.setState({ tab: 'user-info' });
          this.scrollToSlug();
        }
      }
    }

    if (this.props.twitchDrop && this.props.twitchDrop.isUpdating === true && nextProps.twitchDrop.isUpdating === false) {
      if (nextProps.twitchDrop.errors.hasError) {
        if (nextProps.twitchDrop.errors.code === 'E_TWITCH_DROP_SLUG_DUPLICATED') {
          this.setState({ tab: 'user-info' });
          this.scrollToSlug();
        }
      }
    }

    if (this.props.isLoading && !nextProps.isLoading && nextProps.twitchDrop) {
      this.setState({ prevGamesPlayed: (nextProps.twitchDrop.prevGamesPlayed || []) });
    }

    // 当游戏信息加载完成时，获取Steam成就
    if (!this.props.game?.id && nextProps.game?.id) {
      console.log('游戏ID变化，获取Steam成就:', nextProps.game.id);
      // 预加载Steam成就数据（避免在componentWillReceiveProps中直接调用setState）
      setTimeout(() => {
        this.getSteamGameAchievements(nextProps.game.id);
      }, 0);
    }
  }

  getQuestTypeFlags = () => {
    const { questForm = {} } = this.props;
    //判断当前任务是老的视频直播任务
    const streamingQuest = isStreamingQuest(questForm.values);
    //判断当前任务是否是自动结算直播任务
    const autoStreamingQuest = isAutoStreamQuest(questForm.values);
    //判断当前任务是否是二次创作任务
    const secondaryCreationQuest = isSecondaryCreationQuest(questForm.values);
    //判断当前任务是否是新类型任务
    const isNewTypeQuest = autoStreamingQuest || secondaryCreationQuest;
    //判断当前任务是否是非基础任务
    const isStreamOrNewTypeQuest = streamingQuest || autoStreamingQuest;
    return { streamingQuest, autoStreamingQuest, secondaryCreationQuest, isNewTypeQuest, isStreamOrNewTypeQuest };
  }

  getQuest = (quest) => {
    if (quest.comingSoon) return;

    const { auth: { token }, getQuest } = this.props;

    getQuest(quest.id, true, token);
  }

  onDrop = (files, e) => {
    const file = files && files.length ? files[0] : e[0];
    this.setState({
      dropzoneActive: false,
      file,
    });
    const { image } = this.state;
    const format = file.name.split('.')[1];
    const { auth: { token }, requestUploadImageUrl } = this.props;
    const slug = this.getSlug();
    console.log(slug,format,token);
    if (image === 'coverPortrait'||image === 'coverBannel'||image === 'background' ) {
      requestUploadImageUrl(slug, format, token, {
        entityType: 'twitch-drops',
        field: image,
        entityId: this.props.twitchDrop && this.props.twitchDrop.id ? this.props.twitchDrop.id : undefined,
      });
    }

    this.setState({ activeModal: 2 });
  }

  scrollToSlug = () => {
    this.slugE.scrollIntoView({ behavior: 'smooth' });
  }

  submit = (questFormInformation) => {
  console.log('questFormInformation',questFormInformation);
  alert(questFormInformation);
    const {
      autoStreamingQuest,
      secondaryCreationQuest,
      isNewTypeQuest,
    } = this.getQuestTypeFlags();

    const { game, onSubmit, quest } = this.props;
    const { prevGamesPlayed } = this.state;
    // 创建新对象，避免修改原始表单值
    // 对于需要转换的字段，在复制时进行转换
    const questFormInfo = {
      ...questFormInformation,
      // 转换 platforms
      platforms: questFormInformation.platforms&&questFormInformation.platforms.length>0
        ? questFormInformation.platforms.map(p => p.value)
        : [],
      // 转换 countries
      countries: questFormInformation.countries && questFormInformation.countries.length > 0
        ? questFormInformation.countries.map(c => c?.value)
        : questFormInformation.countries,
      // 转换 languages
      languages: questFormInformation.languages && questFormInformation.languages.length > 0
        ? questFormInformation.languages.map(l => l.value)
        : questFormInformation.languages,
    };
    const requiredDateTimeStart = moment(questFormInfo.requiredStartDateTime, 'YYYY-MM-DD');
    const requiredDateTimeEnd = moment(questFormInfo.requiredEndDateTime, 'YYYY-MM-DD');
    const range = requiredDateTimeEnd.diff(requiredDateTimeStart, 'minutes');
    questFormInfo.requiredStreamRangeTime = range;
    questFormInfo.requiredStreamTimeHours = 24;
    if (questFormInfo.requiredStreamTimeMinutes) {
      questFormInfo.requiredStreamTimeMinutes = parseInt(questFormInfo.requiredStreamTimeMinutes, 10);
    }

    if (questFormInfo.paymentAmount) {
      questFormInfo.paymentAmount = parseInt(questFormInfo.paymentAmount, 10);
    }

    if (questFormInfo.dailyEarning) {
      questFormInfo.dailyEarning = parseInt(questFormInfo.dailyEarning, 10);
    }

    if (questFormInfo.miniFollowers) {
      questFormInfo.miniFollowers = parseInt(questFormInfo.miniFollowers, 10);
    }


    if (questFormInfo.viewerTiers && questFormInfo.viewerTiers.length > 0) {
      const isYoutubeVideoQuest = questFormInfo.type === 'youtube-video';
      for (let i = 0; i < questFormInfo.viewerTiers.length; i += 1) {
        questFormInfo.viewerTiers[i].spotsAvailable = parseInt(questFormInfo.viewerTiers[i].spotsAvailable, 10);
        questFormInfo.viewerTiers[i].paymentAmount = parseFloat(questFormInfo.viewerTiers[i].paymentAmount, 10);

        // Parse metric field based on quest type
        if (isYoutubeVideoQuest) {
          if (questFormInfo.viewerTiers[i].minimumAveragePlayCount !== undefined) {
            questFormInfo.viewerTiers[i].minimumAveragePlayCount = parseInt(questFormInfo.viewerTiers[i].minimumAveragePlayCount, 10);
          }
        } else {
          if (questFormInfo.viewerTiers[i].minimumAverageViewers !== undefined) {
            questFormInfo.viewerTiers[i].minimumAverageViewers = parseInt(questFormInfo.viewerTiers[i].minimumAverageViewers, 10);
          }
        }
      }
    }

    if (questFormInfo.memberTiers && questFormInfo.memberTiers.length > 0) {
      for (let k = 0; k < questFormInfo.memberTiers.length; k += 1) {
        const { identity, paymentAmount, type } = questFormInfo.memberTiers[k];
        questFormInfo.memberTiers[k] = {
          identity: identity?.trim(),
          paymentAmount: parseFloat(paymentAmount, 10),
          type: type?.trim(),
        };
      }
    }

    if (questFormInfo.splitTiers && questFormInfo.splitTiers.length > 0) {
      //streamDays, streamHours, maxRevenue, prizePool
      for (let i = 0; i < questFormInfo.splitTiers.length; i += 1) {
        if (autoStreamingQuest) {
          questFormInfo.splitTiers[i].streamDays = parseInt(questFormInfo.splitTiers[i].streamDays, 10);
          // questFormInfo.splitTiers[i].streamHours = parseInt(questFormInfo.splitTiers[i].streamHours, 10);
          // 转换分钟为小时，保留两位小数
          const minutesValue = parseInt(questFormInfo.splitTiers[i].streamHours, 10);
          questFormInfo.splitTiers[i].streamHours = parseFloat((minutesValue / 60).toFixed(2));
        } else if (secondaryCreationQuest) {
          questFormInfo.splitTiers[i].totalUploadDays = parseInt(questFormInfo.splitTiers[i].totalUploadDays, 10);
          questFormInfo.splitTiers[i].validUploadCount = parseInt(questFormInfo.splitTiers[i].validUploadCount, 10);
          questFormInfo.splitTiers[i].totalViews = parseInt(questFormInfo.splitTiers[i].totalViews, 10);
        }
        questFormInfo.splitTiers[i].maxRevenue = parseInt(questFormInfo.splitTiers[i].maxRevenue, 10);
        questFormInfo.splitTiers[i].prizePool = parseInt(questFormInfo.splitTiers[i].prizePool, 10);
      }
    }

    if (questFormInfo.rankTiers && questFormInfo.rankTiers.length > 0) {
      //rankUpper, rankLower, watchTime, prize
      for (let i = 0; i < questFormInfo.rankTiers.length; i += 1) {
        questFormInfo.rankTiers[i].rankUpper = parseInt(questFormInfo.rankTiers[i].rankUpper, 10);
        questFormInfo.rankTiers[i].rankLower = parseInt(questFormInfo.rankTiers[i].rankLower, 10);
        if (autoStreamingQuest) {
          // 转换分钟为小时，保留两位小数
          const minutesValue = parseInt(questFormInfo.rankTiers[i].watchTime, 10);
          questFormInfo.rankTiers[i].watchTime = parseFloat((minutesValue / 60).toFixed(2));
        } else if (secondaryCreationQuest) {
          questFormInfo.rankTiers[i].minTotalViews = parseInt(questFormInfo.rankTiers[i].minTotalViews, 10);
        }
        questFormInfo.rankTiers[i].prize = parseInt(questFormInfo.rankTiers[i].prize, 10);
      }
    }

    questFormInfo.type = questFormInfo.type || 'one-time';

    if (questFormInfo.type === 'tiered-one-time' || questFormInfo.type === 'timed') {
      questFormInfo.frequency = 'one-time';
    }

    if (questFormInfo.type === 'tiered-multi-days' || questFormInfo.type === 'paid bounty') {
      questFormInfo.frequency = 'daily';
    }

    if (isNewTypeQuest) {
      questFormInfo.requirePreapproval = true;
      questFormInfo.frequency = 'daily';
      //判断时间
      const { valid, messages } = isQuestTimeSetValid(quest, questFormInfo);
      if (!valid) {
        simpleNotification({
          level: 'error',
          title: 'Time Validation Error',
          message: messages.join(' '),
        });
        return; // 阻止提交
      }
    }

    if (autoStreamingQuest) {
      questFormInfo.twitchAccountRequired = true;
    }

    if (secondaryCreationQuest) {
      questFormInfo.youtubeAccountRequired = true;
      questFormInfo.requirePreapproval = false;
    }

    if (questFormInfo.type === 'youtube-video') {
      questFormInfo.youtubeAccountRequired = true;
      questFormInfo.twitchAccountRequired = false;
    }

    questFormInfo.group = (questFormInfo.group) ? questFormInfo.group : '';

    console.log('questFormInfo', questFormInfo);

    // 新增：验证Steam Achievement requirements
    if (questFormInfo.requirements) {
      const allRequirements = [
        ...(questFormInfo.requirements.beforeStream || []),
        ...(questFormInfo.requirements.duringStream || []),
        ...(questFormInfo.requirements.afterStream || [])
      ];

      const steamAchievementRequirements = allRequirements.filter(req => req.type === 'submit-steam-achievement');

      if (steamAchievementRequirements.length > 0) {
        // 检查游戏是否有Steam App ID
        if (!game?.steamAppId) {
          simpleNotification({
            level: 'error',
            title: 'Steam Integration Required',
            message: 'This game must have a Steam App ID to use Steam Achievement requirements.',
          });
          return;
        }

        // 验证每个Steam Achievement requirement
        for (const req of steamAchievementRequirements) {
          if (!req.gameAchievements || req.gameAchievements.length === 0) {
            simpleNotification({
              level: 'error',
              title: 'Steam Achievement Required',
              message: `Please select at least one Steam achievement for requirement "${req.title || 'Steam Achievement'}".`,
            });
            return;
          }
        }
      }
    }

    if (questFormInfo.requirements) {
      if (questFormInfo.requirements.beforeStream) {
        for (let i = 0; i < questFormInfo.requirements.beforeStream.length; i += 1) {
          const req = questFormInfo.requirements.beforeStream[i];
          delete questFormInfo.requirements.beforeStream[i].value;
          if (!req.customIcon || req.icon === getDefaultIcon(req.type, req.subtype, questFormInformation, game)) {
            questFormInfo.requirements.beforeStream[i].icon = false;
          }

          if (req.type === 'display-hashtags' || req.type === 'display-stream-time' || (req.type === 'display-text' && req.subtype === 'game-name')) {
            questFormInfo.requirements.beforeStream[i].title = '';
          }
        }
      }

      if (questFormInfo.requirements.duringStream) {
        for (let i = 0; i < questFormInfo.requirements.duringStream.length; i += 1) {
          const req = questFormInfo.requirements.duringStream[i];
          delete questFormInfo.requirements.duringStream[i].value;
          if (req.icon === getDefaultIcon(req.type, req.subtype, questFormInformation, game)) {
            questFormInfo.requirements.duringStream[i].icon = false;
          }

          if (req.type === 'display-hashtags' || req.type === 'display-stream-time' || (req.type === 'display-text' && req.subtype === 'game-name')) {
            questFormInfo.requirements.duringStream[i].title = '';
          }
        }
      }

      if (questFormInfo.requirements.afterStream) {
        for (let i = 0; i < questFormInfo.requirements.afterStream.length; i += 1) {
          const req = questFormInfo.requirements.afterStream[i];
          delete questFormInfo.requirements.afterStream[i].value;
          if (req.icon === getDefaultIcon(req.type, req.subtype, questFormInformation, game)) {
            questFormInfo.requirements.afterStream[i].icon = false;
          }

          if (req.type === 'display-hashtags' || req.type === 'display-stream-time' || (req.type === 'display-text' && req.subtype === 'game-name')) {
            questFormInfo.requirements.afterStream[i].title = '';
          }
        }
      }
    }


    questFormInfo.prevGamesPlayed = prevGamesPlayed.sort();

    onSubmit(questFormInfo);
  }

  swapStep = (kind, index, direction) => {
    const swapIndex = (direction === 'up') ? index - 1 : index + 1;
    const { questForm, swapQuestStep } = this.props;
    let arr;
    if (kind === 'additional-questions') {
      arr = questForm.values.stepsPage1;
    }

    [arr[index], arr[swapIndex]] = [arr[swapIndex], arr[index]];
    swapQuestStep(kind, arr);
  }

  swapRequirement = (pointInQuest, index, direction) => {
    const swapIndex = (direction === 'up') ? index - 1 : index + 1;
    const { questForm, swapRequirements } = this.props;
    const arr = questForm.values.requirements[pointInQuest];
    [arr[index], arr[swapIndex]] = [arr[swapIndex], arr[index]];
    const newRequirements = questForm.values.requirements;
    newRequirements[pointInQuest] = arr;
    swapRequirements(newRequirements);
  }
  handleImageUpload = (imageType, params = {}) => {
    this.setState({
      activeModal: 1,
      image: imageType,
      ...params
    });
  }
  removeIcon = (pointInQuest, index) => {
    this.props.removeIcon({ pointInQuest, index });
  }

  // Steam Achievement相关方法
  // 打开成就选择窗口
  openAchievementModal = (pointInQuest, index, isModifying = false, modifyingAchievementId = null) => {
    this.setState({
      achievementModal: {
        isOpen: true,
        pointInQuest,
        index,
        isModifying,
        modifyingAchievementId
      }
    });
  };

  // 关闭成就选择窗口
  closeAchievementModal = () => {
    this.setState({
      achievementModal: {
        isOpen: false,
        pointInQuest: null,
        index: null,
        isModifying: false,
        modifyingAchievementId: null
      }
    });
  };

  // 从需求中移除成就
  removeAchievement = (achievementId, pointInQuest, index) => {
    const { questForm } = this.props;
    const currentAchievements = questForm?.values?.requirements?.[pointInQuest]?.[index]?.gameAchievements || [];
    const updatedAchievements = currentAchievements.filter(ach => ach.id !== achievementId);
    this.props.dispatch(change('questForm', `requirements.${pointInQuest}[${index}].gameAchievements`, updatedAchievements));
  };

  // 获取 Steam 游戏成就数据（从后端接口）
  getSteamGameAchievements = async (gameId, page = 1, limit = 50, loadMore = false) => {
    if (!gameId) {
      console.warn('gameId为空，无法获取成就');
      return { achievements: [], game: {}, pagination: {}, stats: {} };
    }

    // 防止重复调用
    if (this.state.steamAchievements.isLoading) {
      console.log('成就数据正在加载中，跳过重复请求');
      return { achievements: [], game: {}, pagination: {}, stats: {} };
    }

    // 如果已经有相同gameId的数据且不是强制刷新或加载更多，则跳过
    if (this.state.steamAchievements.game.id === gameId &&
        this.state.steamAchievements.data.length > 0 && !loadMore && page === 1) {
      console.log('成就数据已存在，直接返回');
      return {
        achievements: this.state.steamAchievements.data,
        game: this.state.steamAchievements.game,
        pagination: this.state.steamAchievements.pagination,
        stats: this.state.steamAchievements.stats
      };
    }

    // 设置加载状态
    this.setState(prevState => ({
      steamAchievements: {
        ...prevState.steamAchievements,
        isLoading: true,
        error: null
      }
    }));

    try {
      const { auth: { token } } = this.props;
      const response = await fetch(`/api/v1/admin/game/${gameId}/steam-achievements?page=${page}&limit=${limit}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success && result.data) {
        console.log('获取Steam成就成功:', result.data);

        // 设置成功状态
        this.setState(prevState => ({
          steamAchievements: {
            ...prevState.steamAchievements,
            data: loadMore
              ? [...prevState.steamAchievements.data, ...(result.data.achievements || [])]
              : result.data.achievements || [],
            game: result.data.game || {},
            pagination: result.data.pagination || {},
            stats: result.data.stats || {},
            isLoading: false,
            error: null
          }
        }));

        return {
          achievements: loadMore
            ? [...this.state.steamAchievements.data, ...(result.data.achievements || [])]
            : result.data.achievements || [],
          game: result.data.game || {},
          pagination: result.data.pagination || {},
          stats: result.data.stats || {}
        };
      } else {
        console.error('获取Steam成就失败:', result);

        // 设置错误状态
        this.setState(prevState => ({
          steamAchievements: {
            ...prevState.steamAchievements,
            isLoading: false,
            error: result.message || 'Unknown error'
          }
        }));

        return { achievements: [], game: {}, pagination: {}, stats: {} };
      }
    } catch (error) {
      console.error('获取Steam成就失败:', error);

      // 设置错误状态
      this.setState(prevState => ({
        steamAchievements: {
          ...prevState.steamAchievements,
          isLoading: false,
          error: error.message
        }
      }));

      return { achievements: [], game: {}, pagination: {}, stats: {} };
    }
  };

  // 加载下一页Steam成就
  loadMoreSteamAchievements = async () => {
    const { game } = this.props;
    const { steamAchievements } = this.state;

    if (!steamAchievements.pagination?.page || !steamAchievements.pagination?.pages) {
      return;
    }

    const currentPage = steamAchievements.pagination.page;
    const totalPages = steamAchievements.pagination.pages;

    if (currentPage >= totalPages) {
      return; // 已经是最后一页
    }

    const nextPage = currentPage + 1;
    await this.getSteamGameAchievements(game?.id, nextPage, 50, true);
  };

  // 向需求中添加成就（优先使用缓存数据）
  addAchievementToRequirement = async (achievementId, pointInQuest, index) => {
    const { questForm, game } = this.props;
    const currentAchievements = questForm?.values?.requirements?.[pointInQuest]?.[index]?.gameAchievements || [];

    try {
      let achievements = [];

      // 优先使用已缓存的成就数据
      if (this.state.steamAchievements.data.length > 0 &&
          this.state.steamAchievements.game.id === game?.id) {
        achievements = this.state.steamAchievements.data;
      } else {
        // 如果没有缓存数据，获取新数据
        const result = await this.getSteamGameAchievements(game?.id);
        achievements = result.achievements || [];
      }

      const achievement = achievements.find(ach => ach.id === achievementId);

      if (achievement && !currentAchievements.find(ach => ach.id === achievementId)) {
        const updatedAchievements = [...currentAchievements, achievement];
        this.props.dispatch(change('questForm', `requirements.${pointInQuest}[${index}].gameAchievements`, updatedAchievements));
      }
    } catch (error) {
      console.error('添加成就到需求失败:', error);
    }
  };

  // 从窗口选择成就（优先使用缓存数据）
  selectAchievementFromModal = async (achievementId) => {
    const { achievementModal } = this.state;
    const { questForm, game } = this.props;
    const currentAchievements = questForm?.values?.requirements?.[achievementModal.pointInQuest]?.[achievementModal.index]?.gameAchievements || [];

    try {
      let achievements = [];

      // 优先使用已缓存的成就数据
      if (this.state.steamAchievements.data.length > 0 &&
          this.state.steamAchievements.game.id === game?.id) {
        achievements = this.state.steamAchievements.data;
      } else {
        // 如果没有缓存数据，获取新数据
        const result = await this.getSteamGameAchievements(game?.id);
        achievements = result.achievements || [];
      }

      const achievement = achievements.find(ach => ach.id === achievementId);

      if (achievement) {
        let updatedAchievements;

        if (achievementModal.isModifying && achievementModal.modifyingAchievementId) {
          // 替换现有成就
          updatedAchievements = currentAchievements.map(ach =>
            ach.id === achievementModal.modifyingAchievementId ? achievement : ach
          );
        } else {
          // 添加新成就（如果不存在）
          if (!currentAchievements.find(ach => ach.id === achievementId)) {
            updatedAchievements = [...currentAchievements, achievement];
          } else {
            updatedAchievements = currentAchievements;
          }
        }

        this.props.dispatch(change('questForm', `requirements.${achievementModal.pointInQuest}[${achievementModal.index}].gameAchievements`, updatedAchievements));
      }
    } catch (error) {
      console.error('从窗口选择成就失败:', error);
    }

    this.closeAchievementModal();
  };

  // 渲染Steam Achievement Modal
  renderAchievementModal = () => {
    const { achievementModal, steamAchievements } = this.state;
    const { game } = this.props;

    if (!achievementModal.isOpen) return null;

    return (
      <>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }} onClick={this.closeAchievementModal}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            maxWidth: '800px',
            width: '90%',
            maxHeight: '80%',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
          }} onClick={(e) => e.stopPropagation()}>
            <div style={{
              padding: '20px',
              borderBottom: '1px solid #eee',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <div>
                <h3 style={{ margin: '0 0 4px 0', fontSize: '18px', fontWeight: 'bold', color: '#1a202c' }}>
                  选择Steam成就
                  {steamAchievements.stats?.totalAchievements && (
                    <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#666', marginLeft: '8px' }}>
                      (共 {steamAchievements.stats.totalAchievements} 个)
                    </span>
                  )}
                </h3>
                <p style={{ margin: 0, fontSize: '12px', color: '#666' }}>
                  点击成就即可添加到任务需求中
                </p>
              </div>
              <button
                onClick={this.closeAchievementModal}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#999',
                  padding: '4px',
                  borderRadius: '4px',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f0f0f0';
                  e.target.style.color = '#666';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#999';
                }}
              >
                ×
              </button>
            </div>

            <div style={{ flex: 1, overflow: 'auto', padding: '20px' }}>
              {steamAchievements.isLoading && (
                <div style={{
                  textAlign: 'center',
                  padding: '60px 20px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    border: '3px solid #f3f3f3',
                    borderTop: '3px solid #3182ce',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    marginBottom: '16px'
                  }}></div>
                  <div style={{ fontSize: '14px', color: '#666' }}>正在加载Steam成就...</div>
                </div>
              )}

              {steamAchievements.error && (
                <div style={{
                  textAlign: 'center',
                  padding: '60px 20px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}>
                  <div style={{
                    fontSize: '48px',
                    marginBottom: '16px',
                    color: '#e53e3e'
                  }}>⚠️</div>
                  <div style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: '#e53e3e',
                    marginBottom: '8px'
                  }}>
                    加载失败
                  </div>
                  <div style={{
                    fontSize: '14px',
                    color: '#666',
                    marginBottom: '16px'
                  }}>
                    {steamAchievements.error}
                  </div>
                  <button
                    onClick={() => {
                      // 重置数据并重新获取
                      this.setState(prevState => ({
                        steamAchievements: {
                          ...prevState.steamAchievements,
                          data: [],
                          pagination: {},
                          stats: {},
                          error: null
                        }
                      }));
                      this.getSteamGameAchievements(game?.id);
                    }}
                    style={{
                      backgroundColor: '#3182ce',
                      color: 'white',
                      border: 'none',
                      padding: '8px 16px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '12px'
                    }}
                  >
                    重试
                  </button>
                </div>
              )}

              {!steamAchievements.isLoading && !steamAchievements.error && steamAchievements.data.length === 0 && (
                <div style={{
                  textAlign: 'center',
                  padding: '60px 20px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}>
                  <div style={{
                    fontSize: '48px',
                    marginBottom: '16px',
                    color: '#a0aec0'
                  }}>🏆</div>
                  <div style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: '#4a5568',
                    marginBottom: '8px'
                  }}>
                    暂无可用成就
                  </div>
                  <div style={{
                    fontSize: '14px',
                    color: '#666'
                  }}>
                    该游戏尚未配置Steam成就数据
                  </div>
                </div>
              )}

              {!steamAchievements.isLoading && !steamAchievements.error && steamAchievements.data.map(achievement => (
                <div
                  key={achievement.id}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '16px',
                    margin: '8px 0',
                    backgroundColor: achievement.hidden ? '#fff5f5' : '#f8f9fa',
                    border: `1px solid ${achievement.hidden ? '#fed7d7' : '#e1e5e9'}`,
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    position: 'relative'
                  }}
                  onClick={() => this.selectAchievementFromModal(achievement.id)}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = achievement.hidden ? '#fed7d7' : '#e9ecef';
                    e.currentTarget.style.transform = 'translateY(-1px)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = achievement.hidden ? '#fff5f5' : '#f8f9fa';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <div style={{
                    width: '64px',
                    height: '64px',
                    marginRight: '16px',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    backgroundColor: '#f0f0f0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    border: '2px solid rgba(0,0,0,0.1)'
                  }}>
                    <img
                      src={achievement.icon}
                      alt={achievement.displayName}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        opacity: achievement.hidden ? 0.7 : 1
                      }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        const placeholder = document.createElement('div');
                        placeholder.innerHTML = '🏆';
                        placeholder.style.cssText = 'width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:24px;color:#999;';
                        e.target.parentElement.appendChild(placeholder);
                      }}
                    />
                    {achievement.hidden && (
                      <div style={{
                        position: 'absolute',
                        top: '-6px',
                        right: '-6px',
                        background: 'linear-gradient(45deg, #e53e3e, #c53030)',
                        color: 'white',
                        borderRadius: '50%',
                        width: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '10px',
                        fontWeight: 'bold',
                        border: '2px solid white',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                      }}>
                        ?
                      </div>
                    )}
                  </div>

                  <div style={{ flex: 1 }}>
                    <div style={{
                      fontWeight: 'bold',
                      fontSize: '16px',
                      color: '#1a202c',
                      marginBottom: '4px'
                    }}>
                      {achievement.displayName}
                    </div>
                    <div style={{
                      fontSize: '14px',
                      color: '#4a5568',
                      marginBottom: '8px',
                      lineHeight: '1.4'
                    }}>
                      {achievement.description}
                    </div>
                    <div style={{
                      fontSize: '12px',
                      color: '#2b6cb0',
                      fontWeight: '600'
                    }}>
                      全球完成率: {achievement.globalPercent > 0 ? `${achievement.globalPercent.toFixed(1)}%` : '< 0.1%'}
                    </div>
                  </div>

                  <div style={{
                    padding: '8px 12px',
                    backgroundColor: '#3182ce',
                    color: 'white',
                    borderRadius: '6px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    opacity: 0.8,
                    transition: 'opacity 0.2s'
                  }}>
                    选择
                  </div>
                </div>
              ))}

              {/* 分页信息和分页按钮 */}
              {!steamAchievements.isLoading && !steamAchievements.error && steamAchievements.data.length > 0 && (
                <div style={{
                  marginTop: '20px',
                  padding: '16px',
                  backgroundColor: '#f7fafc',
                  borderRadius: '8px'
                }}>
                  <div style={{
                    fontSize: '14px',
                    color: '#4a5568',
                    marginBottom: '16px',
                    textAlign: 'center'
                  }}>
                    共 {steamAchievements.pagination?.total || steamAchievements.data.length} 个成就
                    {steamAchievements.pagination?.pages > 1 && (
                      <span style={{ marginLeft: '8px' }}>
                        · 第 {steamAchievements.pagination.page || 1} 页，共 {steamAchievements.pagination.pages} 页
                      </span>
                    )}
                  </div>

                  {steamAchievements.pagination?.pages > 1 && (
                    <div style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: '12px'
                    }}>
                      <button
                        onClick={() => {
                          const prevPage = (steamAchievements.pagination.page || 1) - 1;
                          if (prevPage >= 1) {
                            // 重置数据并加载指定页面
                            this.setState(prevState => ({
                              steamAchievements: {
                                ...prevState.steamAchievements,
                                data: []
                              }
                            }));
                            this.getSteamGameAchievements(game?.id, prevPage, 50, false);
                          }
                        }}
                        disabled={steamAchievements.isLoading || (steamAchievements.pagination.page || 1) <= 1}
                        style={{
                          backgroundColor: (steamAchievements.pagination.page || 1) <= 1 ? '#e2e8f0' : '#3182ce',
                          color: (steamAchievements.pagination.page || 1) <= 1 ? '#a0aec0' : 'white',
                          border: 'none',
                          padding: '8px 16px',
                          borderRadius: '6px',
                          cursor: (steamAchievements.pagination.page || 1) <= 1 ? 'not-allowed' : 'pointer',
                          fontSize: '14px',
                          fontWeight: 'bold',
                          transition: 'all 0.2s'
                        }}
                        onMouseEnter={(e) => {
                          if (!steamAchievements.isLoading && (steamAchievements.pagination.page || 1) > 1) {
                            e.target.style.backgroundColor = '#2c5aa0';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!steamAchievements.isLoading && (steamAchievements.pagination.page || 1) > 1) {
                            e.target.style.backgroundColor = '#3182ce';
                          }
                        }}
                      >
                        上一页
                      </button>

                      <span style={{
                        fontSize: '14px',
                        color: '#2d3748',
                        fontWeight: 'bold',
                        minWidth: '100px',
                        textAlign: 'center'
                      }}>
                        {steamAchievements.pagination.page || 1} / {steamAchievements.pagination.pages || 1}
                      </span>

                      <button
                        onClick={() => {
                          const nextPage = (steamAchievements.pagination.page || 1) + 1;
                          if (nextPage <= steamAchievements.pagination.pages) {
                            // 重置数据并加载指定页面
                            this.setState(prevState => ({
                              steamAchievements: {
                                ...prevState.steamAchievements,
                                data: []
                              }
                            }));
                            this.getSteamGameAchievements(game?.id, nextPage, 50, false);
                          }
                        }}
                        disabled={steamAchievements.isLoading || (steamAchievements.pagination.page || 1) >= (steamAchievements.pagination.pages || 1)}
                        style={{
                          backgroundColor: (steamAchievements.pagination.page || 1) >= (steamAchievements.pagination.pages || 1) ? '#e2e8f0' : '#3182ce',
                          color: (steamAchievements.pagination.page || 1) >= (steamAchievements.pagination.pages || 1) ? '#a0aec0' : 'white',
                          border: 'none',
                          padding: '8px 16px',
                          borderRadius: '6px',
                          cursor: (steamAchievements.pagination.page || 1) >= (steamAchievements.pagination.pages || 1) ? 'not-allowed' : 'pointer',
                          fontSize: '14px',
                          fontWeight: 'bold',
                          transition: 'all 0.2s'
                        }}
                        onMouseEnter={(e) => {
                          if (!steamAchievements.isLoading && (steamAchievements.pagination.page || 1) < (steamAchievements.pagination.pages || 1)) {
                            e.target.style.backgroundColor = '#2c5aa0';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!steamAchievements.isLoading && (steamAchievements.pagination.page || 1) < (steamAchievements.pagination.pages || 1)) {
                            e.target.style.backgroundColor = '#3182ce';
                          }
                        }}
                      >
                        下一页
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  };

  uploadToS3 = (file, preSignedUrl) => {
    const { image } = this.state;
    console.log("file size:",file.size);
    if ((image === 'coverPortrait' || image === 'coverBannel' || image === 'background') && file.size > 700000) {
      if (file.size > 700000) {
        simpleNotification({
          level: 'warning',
          title: 'Warning',
          message: 'Image has a limit of 700kb.',
        });
        this.setState({
          activeModal: 1,
        });
        return;
      }
    }
    this.setState({ activeModal: 2 });
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', preSignedUrl);
    xhr.setRequestHeader('Content-Type', file.type);
    xhr.addEventListener('load', this.handleLoad);
    xhr.send(file);
  }

  uploadCoverPortrait = () => {
    const slug = this.getSlug();
    if (!slug) {
      simpleNotification({
        level: 'warning',
        title: 'Warning',
        message: 'Fill Slug field before upload an image.',
      });
      return;
    }
    this.setState({
      activeModal: 1,
      image: 'coverPortrait',
    });
  }

  uploadCoverBannel = () => {
    const slug = this.getSlug();
    if (!slug) {
      simpleNotification({
        level: 'warning',
        title: 'Warning',
        message: 'Fill Slug field before upload an image.',
      });
      return;
    }
    this.setState({
      activeModal: 1,
      image: 'coverBannel',
    });
  }

  uploadBackground = () => {
    const slug = this.getSlug();
    if (!slug) {
      simpleNotification({
        level: 'warning',
        title: 'Warning',
        message: 'Fill Slug field before upload an image.',
      });
      return;
    }
    this.setState({
      activeModal: 1,
      image: 'background',
    });
  }

  getTabClasses = (tab) => {
    const { twitchDropForm } = this.props;
    if (!twitchDropForm) return '';

    const { syncErrors, submitFailed } = twitchDropForm;
    if (!syncErrors || !submitFailed) return '';

    const errorClass = 'fa fa-times-circle red';

    if (tab === 'details') {
      if (
        syncErrors.slug
        || syncErrors.title
        || syncErrors.status
        || syncErrors.isCustomized
        || syncErrors.platforms
        || syncErrors.startDateTime
        || syncErrors.endDateTime
        || syncErrors.coverPortrait
        || syncErrors.coverBannel
        || syncErrors.background
        || syncErrors.group
        || syncErrors.minimumAverageViewers
        || syncErrors.minimumAveragePlayCount
        || syncErrors.requiredBanner
        || syncErrors.bannerLink
      ) {
        return errorClass;
      }
    }


    if (tab === 'faqs') {
      if (
        syncErrors.faqs
      ) {
        return errorClass;
      }
    }
    if (tab === 'activitys') {
      if (
          syncErrors.activitys
      ) {
        return errorClass;
      }
    }
    return '';
  }
  countriesOptions = () => getCountryOptions();
  languagesOptions = () => getLanguageOptions();
  platformOptions = () => {
    const { game: { platforms = [] } } = this.props;
    return getPlatformOptions(platforms);
  }

  handleLoad = (event) => {
    const { preSignedUrl: { data: signedUrl }, updateTwitchDropForm} = this.props;
    const { image } = this.state;

    if (event.target.status !== 200) {
      this.setState({
        activeModal: 0,
      });
      simpleNotification({
        level: 'error',
        title: 'Error',
        message: 'Error uploading the image, try again please.',
      });
      return;
    }

    simpleNotification({
      level: 'success',
      title: 'Success',
      message: 'The image was uploaded succesfully!',
    });

    if (image === 'coverPortrait') {
      updateTwitchDropForm({ coverPortrait: signedUrl.url });
    }else if (image === 'coverBannel') {
      updateTwitchDropForm({ coverBannel: signedUrl.url });
    }else if (image === 'background') {
      updateTwitchDropForm({ background: signedUrl.url });
    }

    this.setState({ activeModal: 0 });
  }
  addRequirement = (fields, req) => {
    const { questForm, game, quest = {} } = this.props;
    // Get preload requirement stuff
    // 确保传递有效的 quest 对象
    const safeQuest = quest || {};
    const preloadedReq = preloadRequirement(req.type, req.subtype, questForm.values, game, safeQuest);

    const newRequirement = {
      type: req.type,
      subtype: req.subtype,
      title: preloadedReq.title,
      description: preloadedReq.description || '',
      label: preloadedReq.label,
      placeholder: preloadedReq.placeholder,
      tooltip: preloadedReq.tooltip,
      approvalRequired: preloadedReq.approvalRequired,
      id: uuidv4().replace(/-/g, ''),
      icon: preloadedReq.icon,
      customIcon: false,
      value: req.value,
    };

    // 为 Steam Achievement 类型添加默认字段
    if (req.type === 'submit-steam-achievement') {
      newRequirement.achievementMustBeCompleted = false;
    }

    fields.push(newRequirement);

    return fields;
  }
  /* START REQUIREMENTS */
  renderRequirements = ({
    fields,
    meta,
    pointInQuest,
  }) => {
    const { game, questForm } = this.props;
    return (
      <Requirements
        fields={fields}
        meta={meta}
        pointInQuest={pointInQuest}
        questForm={questForm}
        game={game}
        onAddRequirement={(fields, req) => this.addRequirement(fields, req)}
        onImageUpload={this.handleImageUpload}
        onSwapRequirement={this.swapRequirement}
        onRichTextUpdate={this.handleRichTextUpdates}
        onOpenAchievementModal={this.openAchievementModal}
        onRemoveAchievement={this.removeAchievement}
      />
    );
  };

  /* END REQUIREMENTS */

  handleRichTextUpdates = (content, formValueString) => {
    console.log('handleRichTextUpdates 收到内容:', content);
    console.log('handleRichTextUpdates 收到表单值字符串:', formValueString);
    this.props.dispatch(change('twitchDropForm', formValueString, content));
  }

  handleTypeChange = (value, form) => {
    const { questForm } = this.props;
    console.log('handleTypeChange', value, form);
    console.log('handleTypeChange questForm', questForm);
    if (value === 'tiered-one-time' || value === 'timed') {
      // form.change('frequency', 'one-time');
    } else if (value === 'tiered-multi-days' || value === 'paid bounty' || value === 'tiered-auto' || value === 'secondary-creation') {
      // form.change('frequency', 'daily');
    }


    // 清空所有 tiers 相关数据 - 无论切换到什么类型都清空
    // 1. 清空 memberTiers
    if (questForm?.values?.memberTiers?.length > 0) {
      this.props.change('memberTiers', []);
    }

    // 2. 清空 viewerTiers
    if (questForm?.values?.viewerTiers?.length > 0) {
      this.props.change('viewerTiers', []);
    }

    // 3. 清空 rankTiers
    if (questForm?.values?.rankTiers?.length > 0) {
      this.props.change('rankTiers', []);
    }

    // 4. 清空 splitTiers
    if (questForm?.values?.splitTiers?.length > 0) {
      this.props.change('splitTiers', []);
    }

    // 5. 清空 Steam Achievement 相关数据 - 当切换到不支持的类型时
    if (value === 'tiered-auto' || value === 'secondary-creation') {
      // 清空所有 requirements 中的 submit-steam-achievement 类型的 requirement
      const requirements = questForm?.values?.requirements;
      if (requirements) {
        const pointInQuestKeys = ['beforeStream', 'duringStream', 'afterStream'];

        pointInQuestKeys.forEach(pointInQuest => {
          if (requirements[pointInQuest] && Array.isArray(requirements[pointInQuest])) {
            // 过滤掉所有 submit-steam-achievement 类型的 requirement
            const filteredRequirements = requirements[pointInQuest].filter(req =>
              req.type !== 'submit-steam-achievement'
            );

            // 如果有 submit-steam-achievement 被过滤掉了，更新 requirements
            if (filteredRequirements.length !== requirements[pointInQuest].length) {
              console.log(`从 ${pointInQuest} 中删除 submit-steam-achievement requirements`);
              this.props.change(`requirements.${pointInQuest}`, filteredRequirements);
            }
          }
        });
      }
    }

    if (value === 'tiered-auto' || value === 'secondary-creation') {
      // form.change('twitchAccountRequired', true);
      // form.change('requirePreapproval', false);
    }

    if (value === 'secondary-creation' || value === 'youtube-video') {
      this.props.change('youtubeAccountRequired', true);
      this.props.change('twitchAccountRequired', false);
    } else {
      this.props.change('youtubeAccountRequired', false);
    }

    if (value === 'tiered-auto') {
      // form.change('requirePreapproval', true);
    }
  }

  handleStartChange = (value) => {
    const { isNewTypeQuest } = this.getQuestTypeFlags();
    console.log('handleStartChange 收到值:', value);

    if (isNewTypeQuest) {
      // 不需要进行时区转换，因为在 CustomDateTimePicker 组件中已经处理过
      this.props.change('openRegistrationDate', value);
    }
  }

  // 当结束时间改变时，将 closeRegistrationDate 更新为相同的值，并将 expectedPayoutDate 设置为结束时间加24小时
  handleEndChange = (value) => {
    const { isNewTypeQuest, secondaryCreationQuest } = this.getQuestTypeFlags();
    console.log('handleEndChange 收到值:', value);

    if (isNewTypeQuest) {
      // 同步设置 Close Registration Date 为 endDateTime
      this.props.change('closeRegistrationDate', value);

      // 计算预计支付日期为 endDateTime 加24小时
      // 使用 moment 处理 ISO 字符串，确保在 UTC 时区进行运算

      let expectedPayout = moment.utc(value)
        .add(24, 'hours')
        .toISOString();
      if (secondaryCreationQuest) {
        expectedPayout = moment.utc(value)
          .add(7 * 24, 'hours')
          .toISOString();
      }
      console.log('计算的预计支付日期:', expectedPayout);
      this.props.change('expectedPayoutDate', expectedPayout);
    }
  }
  renderRankMode = ({ fields, meta }) => (
    <RankMode
      fields={fields}
      meta={meta}
      questForm={this.props.questForm}
      quest={this.props.quest}
      autoStreamingQuest={this.getQuestTypeFlags().autoStreamingQuest}
      secondaryCreationQuest={this.getQuestTypeFlags().secondaryCreationQuest}
    />
  );
  renderSplitMode = ({ fields, meta }) => (
    <SplitMode
      fields={fields}
      meta={meta}
      questForm={this.props.questForm}
      quest={this.props.quest}
      autoStreamingQuest={this.getQuestTypeFlags().autoStreamingQuest}
      secondaryCreationQuest={this.getQuestTypeFlags().secondaryCreationQuest}
    />
  );
  renderWhiteList = ({ fields, meta }) => (
    <WhiteList
      fields={fields}
      meta={meta}
      questForm={this.props.questForm}
      parametersSubTab={this.state.parametersSubTab}
      onRemove={(fields, index) => {
        if (window.confirm(`Are you sure about removing ${this.props.questForm.values.whitelist[index].identity} from this whitelist?`)) {
          fields.remove(index);
        }
      }}
    />
  );
  renderViewerTiers = ({ fields, meta }) => (
    <ViewerTiers
      fields={fields}
      meta={meta}
      questForm={this.props.questForm}
      parametersSubTab={this.state.parametersSubTab}
      streamingQuest={this.getQuestTypeFlags().streamingQuest}
    />
  );
  renderMemberTiers = ({ fields, meta }) => (
    <MemberTiers
      fields={fields}
      meta={meta}
      questForm={this.props.questForm}
      parametersSubTab={this.state.parametersSubTab}
    />
  );
  renderRules = ({ fields, meta, ...custom }) => {
    const { configRules, questForm } = this.props;
    return (
      <Rules
        fields={fields}
        meta={meta}
        configRules={configRules}
        questForm={questForm}
        stepIndex={custom.stepIndex}
      />
    );
  };
  titleSlug = (e, title) => {
    const {
      questForm: { fields: { slug } },
      titleSlugApply,
    } = this.props;

    if (!slug || !slug.visited) {
      titleSlugApply(friendlyURICharacters(replaceSpaces(title)));
    }
  }



  renderTooltip = (label, content) => (
    <label>
      {label}
      <span className="tooltip">
        <i className="tooltip-icon fa fa-info-circle" />
        <div className="tooltip-content">
          {content}
        </div>
      </span>
    </label>
  );

  changeModalState = (value) => {
    this.setState({ activeModal: value });
  }

  onDragEnter = () => {
    this.setState({ dropzoneActive: true });
  }

  onDragLeave = () => {
    this.setState({ dropzoneActive: false });
  }

  getSlug = () => {
    const { twitchDropForm } = this.props;
    console.log(twitchDropForm?.values);
    const { slug:name } = twitchDropForm?.values || {};
    if (!name) {
      return '';
    }
    let slug = name.replace(/[^0-9a-z ]/gi, '');
    slug = slug.split('  ').join(' ');
    slug = slug.split(' ').join('-');
    slug = slug.toLowerCase();
    return slug;
  }
  changeStep = (value) => {
    this.setState({
      activeModal: value,
    });
  }
  render = () => {
    const {
      // auth: { token },
      // game: { id: gameId = '' },
      handleSubmit,
      // pathname,
      // preSignedUrl: { isLoading },
      twitchDrop = {},
      twitchDropForm = {},
    } = this.props;
  console.log('twitchDrop',twitchDrop,twitchDropForm?.values);
    // const pathSegs = pathname.split('/');
    // const action = pathSegs[pathSegs.length - 1];
    // const dateStoreFormat = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]'; // ISO 8601格式，与服务器匹配
    // const dateDisplayFormat = 'MM-DD-YYYY HH:mm'; // 本地显示格式

    const {
      activeModal,
      // disableClick,
      // dropzoneActive,
      // parametersSubTab,
      // parametersAwardMode,
      // prevGamesPlayed,
      // subTab,
      tab
    } = this.state;

    // Check for "Send failure email" functionality
    // const emailFailureSentDate = (twitchDropForm.values && twitchDropForm.values.emailFailure && twitchDropForm.values.emailFailure.sentDate) ? moment(twitchDropForm.values.emailFailure.sentDate).format('MMMM DD, YYYY - hh:mm a') : false;
    //
    // // Check for "Send reminder email" functionality
    // const emailReminderSentDate = (twitchDropForm.values && twitchDropForm.values.emailReminder && twitchDropForm.values.emailReminder.sentDate) ? moment(twitchDropForm.values.emailReminder.sentDate).format('MMMM DD, YYYY - hh:mm a') : false;

    // let questMeetsReminderMin = true;
    if (twitchDropForm.values && twitchDropForm.values.startDateTime && twitchDropForm.values.endDateTime && twitchDropForm.values.openRegistrationDate && twitchDropForm.values.closeRegistrationDate && twitchDropForm.values.expectedPayoutDate) {
      // questMeetsReminderMin = !(getQuestDurationHours(twitchDropForm.values) <= 48);
      // 移除这些格式转换，因为它们在CustomDateTimePicker组件内部已经正确处理了
      // 这些转换会导致时区问题，因为它们转换为字符串并丢失时区信息
      // questForm.values.startDateTime = moment.utc(questForm.values.startDateTime).local().format('YYYY-MM-DD HH:mm')
      // questForm.values.endDateTime = moment.utc(questForm.values.endDateTime).local().format('YYYY-MM-DD HH:mm')
      // questForm.values.openRegistrationDate = moment.utc(questForm.values.openRegistrationDate).local().format('YYYY-MM-DD HH:mm')
      // questForm.values.closeRegistrationDate = moment.utc(questForm.values.closeRegistrationDate).local().format('YYYY-MM-DD HH:mm')
      // questForm.values.expectedPayoutDate = moment.utc(questForm.values.expectedPayoutDate).local().format('YYYY-MM-DD HH:mm')
      // console.log('questForm.values.startDateTime', questForm.values.startDateTime)
      // console.log('quest.endDateTime', quest.endDateTime)
    }

    const detailsTabClasses = this.getTabClasses('details');
    const faqsTabClasses = this.getTabClasses('faqs');
    const activitysTabClasses = this.getTabClasses('activitys');
    console.log(detailsTabClasses,faqsTabClasses,activitysTabClasses);


    // 使用封装好的方法，获得任务类型 flags
    // const {
    //   streamingQuest,
    //   secondaryCreationQuest,
    //   isNewTypeQuest,
    //   isStreamOrNewTypeQuest,
    // } = this.getQuestTypeFlags();

    // const isYoutubeVideoQuest = twitchDropForm?.values?.type === 'youtube-video';

    let imageText = 'Overlay Image';
    let lessThan = 700;
    let recommendedDimensions = '1700px x 956px (16:9)';


    return (
      <div>
        {/* Global Tabs */}
        <div className="Global__tabs">
          <div className={classNames('Global__tab', { active: tab === 'details' })} onClick={() => this.setState({ tab: 'details' })} aria-hidden>Details<i className={detailsTabClasses} /></div>
          <div className={classNames('Global__tab', { active: tab === 'faq' })} onClick={() => this.setState({ tab: 'faq' })} aria-hidden>FAQ<i className={faqsTabClasses} /></div>
          <div className={classNames('Global__tab', { active: tab === 'activity' })} onClick={() => this.setState({ tab: 'activity' })} aria-hidden>Drop Activity<i className={activitysTabClasses} /></div>
        </div>
        <form className="form-container quests-edit" autoComplete="off" onSubmit={handleSubmit(this.submit.bind(this))}>
          <div className="info-tab-wrap" style={(tab === 'details') ? { display: 'block' } : { display: 'none' }}>

            <Field
                type="text"
                name="title"
                id="title"
                placeholder="Title"
                customLabel="Title"
                component={CustomInput}
                normalize={title => friendlyURICharacters(replaceSpaces(title))}
            />

            <Field
                type="text"
                name="slug"
                id="slug"
                placeholder="Slug"
                customLabel="Slug"
                component={CustomInput}
            />

            {twitchDropForm.values && (
                <label className="Label__URL">
                  URL: {window.location.origin}/twitch-drop/{twitchDropForm.values.slug}
                </label>
            )}

            <div className="input-container main_desc">
              <label>About Description</label>
              {twitchDropForm?.values && (
                  <RichText
                      initialValue={twitchDropForm.values.description}
                      callback={content => this.handleRichTextUpdates(content, 'description')}
                  />
              )}
            </div>
            <div style={{marginTop:'10px'}}>
              <Field
                  name="isCustomized"
                  id="isCustomized"
                  type="checkbox"
                  placeholder="Select Value"
                  customLabel="Is Customized"
                  component={CustomInputCheckbox}
              />
            </div>

            <Field
              name="platforms"
              id="platforms"
              isMulti
              component={ArrayDropDown}
              styles={arrayDropDownColors}
              customLabel={<label>Platforms</label>}
              optionsToRender={this.platformOptions()}
            />
            <Field
                type="text"
                name="coverPortrait"
                id="coverPortrait"
                placeholder="Cover Portrait Link"
                customLabel={(
                    <label>
                      Cover Link&nbsp;&nbsp;
                      <div
                          className="GameEdit__upload"
                          onClick={this.uploadCoverPortrait.bind(this)}
                          aria-hidden
                      >
                        (Upload Cover Portrait Image)(3:4)
                      </div>
                    </label>)}
                component={CustomInput}
            />
            <Field
                type="text"
                name="coverBannel"
                id="coverBannel"
                placeholder="Bannel Link"
                customLabel={(
                    <label>
                      Bannel Link&nbsp;&nbsp;
                      <div
                          className="GameEdit__upload"
                          onClick={this.uploadCoverBannel.bind(this)}
                          aria-hidden
                      >
                        (Upload Bannel Image)(16:9)
                      </div>
                    </label>)}
                component={CustomInput}
            />
            <Field
                type="text"
                name="background"
                id="background"
                placeholder="Required Overlay Image"
                customLabel={(
                    <label>
                      BackgroundImage&nbsp;&nbsp;
                      <div
                          className="GameEdit__upload"
                          onClick={this.uploadBackground.bind(this)}
                          aria-hidden
                      >
                        (Upload Overlay Image)
                      </div>
                    </label>)}
                component={CustomInput}
            />
            {/*<Field*/}
            {/*    type="text"*/}
            {/*    name="startDateTime"*/}
            {/*    id="startDateTime"*/}
            {/*    placeholder="Start Date"*/}
            {/*    dateStoreFormat={DATE_STORE_FORMAT}*/}
            {/*    dateDisplayFormat={dateDisplayFormat}*/}
            {/*    customLabel="Start Date"*/}
            {/*    component={CustomDateTimePicker}*/}
            {/*    onChange={(e, v) => this.handleStartChange(v)}*/}
            {/*/>*/}
            {/*<Field*/}
            {/*    type="text"*/}
            {/*    name="endDateTime"*/}
            {/*    id="endDateTime"*/}
            {/*    placeholder="End Date"*/}
            {/*    dateStoreFormat={DATE_DISPLAY_FORMAT}*/}
            {/*    dateDisplayFormat={dateDisplayFormat}*/}
            {/*    customLabel="End Date"*/}
            {/*    component={CustomDateTimePicker}*/}
            {/*    onChange={(e, v) => this.handleEndChange(v)}*/}
            {/*/>*/}
          </div>
          <div className="info-tab-wrap" style={(tab === 'faq') ? { display: 'block' } : { display: 'none' }}>
            <FieldArray
              name="faqs"
              component={FAQs}
              props={{
                onRemove: (fields, index) => {
                  fields.remove(index);
                  this.faqs = this.faqs.splice(index, 1);
                },
                onRichTextUpdate: this.handleRichTextUpdates
              }}
            />
          </div>
          <div className="info-tab-wrap" style={(tab === 'activity') ? { display: 'block' } : { display: 'none' }}>
            <FieldArray
                name="activitys"
                component={DropActivitys}
                props={{
                  onRemove: (fields, index) => {
                    fields.remove(index);
                    this.activitys = this.activitys.splice(index, 1);
                  },
                  onRichTextUpdate: this.handleRichTextUpdates
                }}
            />
          </div>
          <div className="form__footer">
            <input
                type="submit"
                className="CCQuests__save--btn"
                value="Save"
            />
          </div>
        </form>
        <section className="ModalMaster">
          <section className={classNames('Modal Modal__upload Modal__upload__one', { active: activeModal === 1 })}>
            <div onClick={this.changeStep.bind(this, 0)} className="Modal__layer" role="button" aria-hidden />
            <section className="Modal__wrapper">
              {
                  (this.props.preSignedUrl && this.props.preSignedUrl.isLoading)
                  &&
                  <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
              }
              {
                  (!this.props.preSignedUrl || !this.props.preSignedUrl.isLoading)
                  &&
                  <React.Fragment>
                    <div className={classNames('Modal__upload__border', { active: this.state.dropzoneActive })} />
                    <div
                        className="Modal__close-btn"
                        style={{ display: (this.state.dropzoneActive) ? 'none' : 'block' }}
                        onClick={this.changeStep.bind(this, 0)}
                        role="button"
                        aria-hidden
                    />
                    <Dropzone
                        ref={(node) => { this.dropzoneRef = node; }}
                        disableClick={this.state.disableClick}
                        className="Modal__upload__content"
                        onDrop={(e, event) => this.onDrop(event, e)}
                        onDragEnter={this.onDragEnter.bind(this)}
                        onDragLeave={this.onDragLeave.bind(this)}
                        disablePreview={false}
                        multiple={false}
                        accept={['.jpg', '.png']}
                        inputProps={{ id: 'file' }}
                    >
                      <div className="Modal__upload__image" />
                      <div className="Modal__upload__title">
                        Drag and drop the {imageText} here
                      </div>
                      <div
                          className="Modal__upload__or"
                      >
                        Or
                      </div>
                      <div
                          className="Modal__upload__action"
                      >
                        <input type="file" name="file" id="file" className="inputFile" onChange={this.handleSelectedFile} />
                        <button className="cta__button">Choose a file</button>
                      </div>
                      <div
                          className="Modal__upload__or"
                      >
                        Mandatory Size: Less than {lessThan}kb
                        {
                            (recommendedDimensions) &&
                            <React.Fragment><br />Recommended Dimensions: {recommendedDimensions}</React.Fragment>
                        }
                      </div>
                    </Dropzone>
                  </React.Fragment>
              }
            </section>
          </section>
          <section className={classNames('Modal Modal__upload Modal__upload__two', { active: activeModal === 2 })}>
            <div onClick={this.changeStep.bind(this, 0)} className="Modal__layer" role="button" aria-hidden />
            <section className="Modal__wrapper">
              <div className="Modal__upload__border" />
              <div onClick={this.changeStep.bind(this, 0)} className="Modal__close-btn" role="button" aria-hidden />
              <section className="Modal__upload__content">
                <div className="Modal__upload__image" />
                <div className="Modal__upload__title">
                  Uploading the image
                </div>
                <div className="Modal__upload__loading">
                  <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
                </div>
              </section>
            </section>
          </section>
          <section className={classNames('Modal Modal__upload Modal__upload__three', { active: activeModal === 3 })}>
            <div onClick={this.changeStep.bind(this, 0)} className="Modal__layer" role="button" aria-hidden />
            <section className="Modal__wrapper">
              <div onClick={this.changeStep.bind(this, 0)} className="Modal__close-btn" role="button" aria-hidden />
              <section className="Modal__upload__content">
                <section className="Modal__upload__avatar">
                  <div className="Modal__upload__avatar--container" aria-hidden />
                </section>
                <div className="Modal__upload__title2">
                  Upload completed
                </div>
                <div onClick={this.changeStep.bind(this, 0)} className="Modal__upload__button" aria-hidden>
                  Change Image
                </div>
              </section>
            </section>
          </section>
        </section>
      </div>
    );
  }
}

const validate = (values) => {
  const errors = {};
  if (!values.title || values.title.trim() === '') {
    errors.title = 'This field is required';
  }
  if (!values.slug || values.slug.trim() === '') {
    errors.slug = 'This field is required';
  }
  if (!values.description || values.description.trim() === '') {
    errors.description = 'This field is required';
  }
  if (values.isCustomized && !isBoolean(values.isCustomized)) {
    errors.isCustomized = 'This field is required';
  }
  if (!values.platforms||values.platforms?.length <= 0) {
    errors.platforms = 'This field is required';
  }
  // 支持ISO格式和自定义格式的日期验证
  // const dateStoreFormat = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
  // const isValidStartDate = moment(values.startDateTime, moment.ISO_8601, true).isValid()
  //     || moment(values.startDateTime, dateStoreFormat, true).isValid();
  //
  // const isValidEndDate = moment(values.endDateTime, moment.ISO_8601, true).isValid()
  //     || moment(values.endDateTime, dateStoreFormat, true).isValid();
  // if (!values.startDateTime) {
  //   errors.startDateTime = 'This field is required';
  // } else if (!isValidStartDate) {
  //   errors.startDateTime = `This date is not valid`;
  // }
  // if (!values.endDateTime) {
  //   errors.endDateTime = 'This field is required';
  // } else if (!isValidEndDate) {
  //   errors.endDateTime = `This date is not valid`;
  // }
  // if (!errors.startDateTime && !errors.endDateTime) {
  //   const startDate = moment(values.startDateTime);
  //   const endDate = moment(values.endDateTime);
  //
  //   if (endDate.isBefore(startDate)) {
  //     errors.endDateTime = 'End date must be after start date';
  //   }
  // }
  if(!values.activitys||values.activitys.length===0){
    errors.activitys = 'This field is required';
  }
  if(values.activitys&&values.activitys.length>0){
    // errors.activitys = 'This field is required';
    const filterActivitys = values.activitys.filter(activity=>!activity.title||activity.title===null||!activity.startDateTime||activity.startDateTime===null||activity.startDateTime.trim()===''
        ||!activity.endDateTime||activity.endDateTime===null||activity.endDateTime.trim()===''||moment(activity.endDateTime).isBefore(moment(activity.startDateTime)));
    if(filterActivitys&&filterActivitys.length>0){
      errors.activitys = 'This field is required';
    }
  }
  console.log("errors",errors);
  return errors;
};

TwitchDropForm.propTypes = {
   onSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'twitchDropForm',
  validate,
})(TwitchDropForm);
